import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Project from "./index";
import TaskDetailRoute from "./tasks/taskDetailRoute";
function MainRout(props) {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Project {...props} />} />
        <Route path="/task/:id" element={<TaskDetailRoute {...props} />} />
      </Routes>
    </div>
  );
}

export default MainRout;
